export const getPageName = (hostname: string) => {
  if (hostname.includes("localhost")) {
    return "PRO Local";
  } else if (hostname.includes("rap.dev")) {
    return "PRO Dev";
  } else if (hostname.includes("rap.demo")) {
    return "PRO Demo";
  } else if (hostname.includes("rajosszikviz")) {
    return "RORA";
  } else if (hostname.includes("sch-ps")) {
    return "SCH-ps";
  } else if (hostname.includes("magero")) {
    return "Magerő";
  } else {
    return "PRO";
  }
};
